<div class="hvac-section-select">
    <form class="hvac-small-only" [formGroup]="formGroup">
        <utc-select
            variant="primary"
            [group]="formGroup"
            [control]="control"
            [selectId]="selectId"
            [options]="options"
        >
        </utc-select>
    </form>

    <ul class="hvac-large-only hvac-section-select-list">
        <li *ngFor="let option of options" class="hvac-rhythm-1">
            <a *ngIf="option.action === 'link'; else newTab" [routerLink]="[option.value]" routerLinkActive="hvac-active" title="{{option.name}}" class="hvac-section-select-link hvac-p-sm">{{option.name}}</a>
            <ng-template #newTab>
                <a class="hvac-section-select-link hvac-p-sm" href="{{option.value}}" target="_blank">
                    {{ option.name }}
                </a>
            </ng-template>
        </li>
    </ul>
</div>
